<div class="preview-wrapper animated fadeIn" *ngIf="data?.text_data">
    <p>{{data.text_data.text}}</p>
</div>